export default __webpack_public_path__ + "static/daze-days-logo-4a13d8d796d06373eb93e8061c9fed24.png";